<!-- <template>
  <AlertMessage :type="errorMessage.type" icon="alert-triangle" class="max-w-xl m-auto my-24">
      <template #title>{{ errorMessage.title }}</template>
      <template #body>
          <div class="prose" v-html="errorMessage.description" />
          <router-link
              v-if="errorMessage.link"
              :to="{ path: errorMessage.link }"
              class="mt-2 text-cobalt-500 font-semibold block"
              >Purchase here</router-link
          >
      </template>
  </AlertMessage>
</template> -->

<template>
  <div class="container d-flex flex-column align-items-center justify-content-center">
      <div class="col-md-10 col-lg-9 col-xl-8 m-5 mx-auto">
          <div class="card mb-3 rounded-4 overflow-hidden">
              <div class="row g-0">
                  <div class="col-sm-5 d-flex align-items-end position-relative overflow-hidden">
                      <div class="bg-gradient-circle position-absolute z-0 w-75 h-100"></div>
                      <img :src="doctor" class="img-fluid mt-5 mx-auto z-1"
                          alt="Health">
                  </div>
                  <div class="col-sm-7">
                      <div
                          class="card-body d-flex flex-column align-items-start justify-content-center h-100 p-4">
                          <h5 class="card-title text-start my-3" v-if="errorMessage.title">{{ errorMessage.title }}</h5>
                          <!-- <p class="card-text text-start">{{ details.heading }}</p> -->
                          <p class="card-text text-start">
                              <small class="text-muted" v-html="errorMessage.description"></small>
                          </p>
                          <router-link v-if="errorMessage.link" :to="{ path: errorMessage.link }">
                              <button class="btn btn-primary">Explore</button>
                          </router-link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<style lang="scss" scoped>
.bg-gradient-circle {
  background: url('@/assets/gradient-circle.png') no-repeat;
  background-position: right;
  // background-size: cover;
}

img {
  max-height: 330px;
}
</style>
<script setup>
//import AlertMessage from "@/components/AlertMessage.vue";
import doctor from "@/assets/characters/blood-test-inspiration-new.png";
import { computed } from "vue";
import store from "@/store/index";

const error = {
  type: "error",
  title: "Processing failed",
  description:
      "Unfortunately something went wrong providing your Classical DNA result. Please contact support at <a href='mailto:help@livingdna.com' class='font-semibold text-cobalt-500'>help@livingdna.com</a>",
  link: "",
};

const processing = {
  type: "info",
  title: "Result processing",
  description: "Your Classical DNA result is processing and should be available within 48 hours",
  link: "",
};

const errorMessages = {
  error,
  failed: error,
  noData: error,
  pending: processing,
  processing,
};

// A status this page doesn't know reads as still processing, rather than a blank page
const errorMessage = computed(() => errorMessages[store.getters.kitTests?.classical?.status] ?? processing);
</script>
